var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _path38, _path39, _path40, _line, _path41, _path42, _line2, _path43, _path44, _line3, _path45, _path46, _path47, _g, _path48, _path49, _circle18, _path50, _circle19, _path51, _ellipse, _mask, _g2, _ellipse2, _ellipse3, _path52, _ellipse4, _mask2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllCartSuccessstyled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 343,
    viewBox: "0 0 343 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319 224.604C319 161.083 281.987 13.2096 196.409 63.3579C110.831 113.506 27 121.949 27 220.017C27 296.354 67.7701 321 163.358 321C249.436 321 319 303.17 319 224.604Z",
    fill: "var(--color-theme_clubNavigation1, var(--color-theme_clubNavigation1-override, rgba(51,51,51,1)))",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3933 95.0092L73 81.2794",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2009 104.11L84.5645 111.064",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2356 90.5172C95.4243 87.7713 89.8015 82.2794 89.8015 82.2794",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.844 91.7731L94.5904 70.1129",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.081 91.7347V71.8057",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.081 129.208V107.188",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4719 107.562L87.8014 119.386",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.028 99.5591H115.2",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1091 99.5591H85.281",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.041 107.62L98.9217 117.133",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.219 107.601L115.711 120.939",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M135.599 127.208L113.622 106.795",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.086 106.541L115.535 103.109",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M115.436 81.6915L111.906 89.5369",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.864 87.3985L115.613 95.9307",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M129.088 78.2393L114.671 92.5575",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M109.827 101.913L104.629 96.715",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M109.827 96.715L104.63 101.913",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.40355,
    transform: "matrix(-1 0 0 1 81.0173 107.136)",
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2.80542,
    transform: "matrix(-1 0 0 1 130.01 109.601)",
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 2.80542,
    transform: "matrix(-1 0 0 1 121.086 72.8055)",
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 1.40271,
    transform: "matrix(-1 0 0 1 115.074 129.718)",
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 1.40271,
    transform: "matrix(-1 0 0 1 83.3097 81.2797)",
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 1.40271,
    transform: "matrix(-1 0 0 1 112.622 76.6108)",
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M243.848 64.2592L281.564 45.0238",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M244.216 74.0666L281.933 93.3019",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M247.996 53.6987C253.401 48.4185 264.214 37.858 264.214 37.858",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M239.132 58.0358L249.504 28.0507",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M232.909 61.8079V32.2009",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M232.909 118.482V76.1403",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M241.774 78.7814L270.438 107.823",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M198.399 69.1626H224.99",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M240.547 69.1626H267.138",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M238.756 82.7408L246.676 101.033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M226.875 84.626L216.314 110.273",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M188.028 114.988L224.179 79.2315",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M204.057 80.6663L218.578 74.066",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M218.766 36.7266L225.554 51.8127",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M187.273 49.9277L216.503 62.1854",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M194.439 32.0123L222.161 59.5451",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M227.629 73.6885L237.624 63.6935",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M227.63 63.6935L237.625 73.6885",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.611,
    cy: 114.16,
    r: 5.3946,
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 113,
    r: 2.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.792,
    cy: 75.2715,
    r: 5.3946,
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 278,
    cy: 74.0001,
    r: 2.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.395,
    cy: 86.808,
    r: 5.3946,
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 86.0001,
    r: 2.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.057,
    cy: 22.3947,
    r: 5.3946,
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.5,
    cy: 21.5001,
    r: 2.5,
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 221.071,
    cy: 122.049,
    r: 2.6973,
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.958,
    cy: 35.6759,
    r: 2.6973,
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.179,
    cy: 28.8804,
    r: 2.6973,
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.5 210.246V221.246C283.5 223.692 282.397 226.069 280.317 228.345L275.878 267.88C275.633 270.063 274.677 272.094 272.926 273.421C264.899 279.504 236.785 296.246 170.5 296.246C104.215 296.246 76.1009 279.504 68.074 273.421C66.3231 272.094 65.3673 270.063 65.1221 267.88L60.6832 228.345C58.6027 226.069 57.5001 223.692 57.5001 221.246V210.246C57.5001 193.677 108.092 180.246 170.5 180.246C232.908 180.246 283.5 193.677 283.5 210.246Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M280.317 228.345L275.888 224.297C275.033 225.233 274.496 226.416 274.354 227.676L280.317 228.345ZM275.878 267.88L269.915 267.21V267.21L275.878 267.88ZM272.926 273.421L269.302 268.639L269.302 268.639L272.926 273.421ZM68.074 273.421L71.6978 268.639L68.074 273.421ZM65.1221 267.88L71.0847 267.21L65.1221 267.88ZM60.6832 228.345L66.6457 227.676C66.5043 226.416 65.9673 225.233 65.1119 224.297L60.6832 228.345ZM289.5 221.246V210.246H277.5V221.246H289.5ZM284.746 232.394C287.5 229.38 289.5 225.624 289.5 221.246H277.5C277.5 221.759 277.295 222.758 275.888 224.297L284.746 232.394ZM274.354 227.676L269.915 267.21L281.841 268.549L286.279 229.015L274.354 227.676ZM269.915 267.21C269.812 268.129 269.474 268.509 269.302 268.639L276.55 278.203C279.88 275.68 281.453 271.997 281.841 268.549L269.915 267.21ZM269.302 268.639C262.511 273.786 235.741 290.246 170.5 290.246V302.246C237.83 302.246 267.288 285.222 276.55 278.203L269.302 268.639ZM170.5 290.246C105.259 290.246 78.4895 273.786 71.6978 268.639L64.4502 278.203C73.7123 285.222 103.17 302.246 170.5 302.246V290.246ZM71.6978 268.639C71.5257 268.509 71.1878 268.129 71.0847 267.21L59.1596 268.549C59.5467 271.997 61.1205 275.68 64.4502 278.203L71.6978 268.639ZM71.0847 267.21L66.6457 227.676L54.7207 229.015L59.1596 268.549L71.0847 267.21ZM51.5001 221.246C51.5001 225.624 53.5002 229.38 56.2545 232.393L65.1119 224.297C63.7052 222.758 63.5001 221.759 63.5001 221.246H51.5001ZM51.5001 210.246V221.246H63.5001V210.246H51.5001ZM170.5 174.246C138.931 174.246 110.139 177.636 89.0574 183.233C78.5608 186.02 69.6346 189.442 63.1904 193.486C57.0528 197.339 51.5001 202.848 51.5001 210.246H63.5001C63.5001 209.359 64.2713 206.976 69.57 203.65C74.562 200.517 82.1843 197.474 92.1366 194.832C111.953 189.571 139.661 186.246 170.5 186.246V174.246ZM289.5 210.246C289.5 202.848 283.947 197.339 277.81 193.486C271.366 189.442 262.439 186.02 251.943 183.233C230.861 177.636 202.069 174.246 170.5 174.246V186.246C201.339 186.246 229.047 189.571 248.864 194.832C258.816 197.474 266.438 200.517 271.43 203.65C276.729 206.976 277.5 209.359 277.5 210.246H289.5Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M114.158 144.488C115.072 144.858 114.73 146.266 113.793 146.571C111.293 147.384 108.793 149.143 106.292 151.359C105.758 151.832 105.901 152.695 106.537 153.02C108.749 154.151 110.96 155.651 113.172 157.86C113.971 158.658 112.648 160.325 111.532 160.154C101.675 158.64 91.818 169.531 81.9609 162.919C81.6943 162.74 81.5335 162.431 81.5335 162.11C81.5335 157.423 81.5335 152.736 81.5335 148.048C81.5335 147.231 82.4811 146.749 83.2028 147.133C93.5213 152.618 103.84 140.302 114.158 144.488Z",
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 85.5001,
    y1: 150.85,
    x2: 85.5001,
    y2: 161.85,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9298 138.936C77.0026 138.936 77.0745 138.936 77.1473 138.936C78.6966 139.118 79.7027 140.024 79.9977 141.471C80.3057 142.983 79.5991 144.227 78.7498 144.845C78.6378 144.929 78.411 145.005 78.3746 145.126C78.2953 145.391 78.3746 146 78.3746 146.424C78.3746 173.493 78.3746 162.833 78.3746 189.831C78.3783 189.853 78.3709 179.866 78.355 189.871C77.4842 189.871 76.6134 189.871 75.7426 189.871C75.6997 189.874 75.6791 189.854 75.6838 189.81C75.6838 162.231 75.6838 172.667 75.6838 145.085C74.7841 144.527 74.1298 143.724 74.0001 142.391C74.0001 142.243 74.0001 142.098 74.0001 141.95C74.2362 140.199 75.1611 139.142 76.9298 138.936Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M211.158 132.488C212.072 132.858 211.73 134.266 210.793 134.571C208.293 135.384 205.793 137.143 203.292 139.359C202.758 139.832 202.901 140.695 203.537 141.02C205.749 142.151 207.96 143.651 210.172 145.86C210.971 146.658 209.648 148.325 208.532 148.154C198.675 146.64 188.818 157.531 178.961 150.919C178.694 150.74 178.534 150.431 178.534 150.11C178.534 145.423 178.534 140.736 178.534 136.048C178.534 135.231 179.481 134.749 180.203 135.133C190.521 140.618 200.84 128.302 211.158 132.488Z",
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 182.5,
    y1: 138.85,
    x2: 182.5,
    y2: 149.85,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.93 126.936C174.003 126.936 174.074 126.936 174.147 126.936C175.697 127.118 176.703 128.024 176.998 129.471C177.306 130.983 176.599 132.227 175.75 132.845C175.638 132.929 175.411 133.005 175.375 133.126C175.295 133.391 175.375 134 175.375 134.424C175.375 161.493 175.375 150.833 175.375 177.831C175.378 177.853 175.371 167.866 175.355 177.871C174.484 177.871 173.613 177.871 172.743 177.871C172.7 177.874 172.679 177.854 172.684 177.81C172.684 150.231 172.684 160.667 172.684 133.085C171.784 132.527 171.13 131.724 171 130.391C171 130.243 171 130.098 171 129.95C171.236 128.199 172.161 127.142 173.93 126.936Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M302.158 144.488C303.072 144.858 302.73 146.266 301.793 146.571C299.293 147.384 296.793 149.143 294.292 151.359C293.758 151.832 293.901 152.695 294.537 153.02C296.749 154.151 298.96 155.651 301.172 157.86C301.971 158.658 300.648 160.325 299.532 160.154C289.675 158.64 279.818 169.531 269.961 162.919C269.694 162.74 269.534 162.431 269.534 162.11C269.534 157.423 269.534 152.736 269.534 148.048C269.534 147.231 270.481 146.749 271.203 147.133C281.521 152.618 291.84 140.302 302.158 144.488Z",
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 273.5,
    y1: 150.85,
    x2: 273.5,
    y2: 161.85,
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.93 138.936C265.003 138.936 265.074 138.936 265.147 138.936C266.697 139.118 267.703 140.024 267.998 141.471C268.306 142.983 267.599 144.227 266.75 144.845C266.638 144.929 266.411 145.005 266.375 145.126C266.295 145.391 266.375 146 266.375 146.424C266.375 173.493 266.375 162.833 266.375 189.831C266.378 189.853 266.371 179.866 266.355 189.871C265.484 189.871 264.613 189.871 263.743 189.871C263.7 189.874 263.679 189.854 263.684 189.81C263.684 162.231 263.684 172.667 263.684 145.085C262.784 144.527 262.13 143.724 262 142.391C262 142.243 262 142.098 262 141.95C262.236 140.199 263.161 139.142 264.93 138.936Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2595 222.571L65.1222 265.88C65.3673 268.063 66.3231 270.094 68.074 271.421C76.1009 277.504 104.215 294.246 170.5 294.246C236.785 294.246 264.899 277.504 272.926 271.421C274.677 270.094 275.633 268.063 275.878 265.88L280.741 222.571C271.358 236.599 225.571 247.246 170.5 247.246C115.429 247.246 69.6419 236.599 60.2595 222.571Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M259 280L262.5 237L277.5 231L274 272L259 280Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0001 248C69.7503 254 90.7887 264.501 128.563 269.375M277 248C271.25 254 251.961 264.501 215 269.375",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "3 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0001 237C71.0842 244.667 105.806 260 172.019 260C238.232 260 270.262 244.667 278 237",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "3 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0001 258C69.7167 264.468 90.5798 275.763 128 281.077M277 258C271.224 264.529 251.788 275.978 214.5 281.228",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "3 8"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M144 267H199V281C199 281 189.392 286 171.169 286C152.946 286 144 281 144 281V267Z",
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M128 292V270.469C128 268.085 130.063 266.217 132.438 266.42C139.285 267.007 153.53 268 171.5 268C189.47 268 203.716 267.007 210.562 266.42C212.937 266.217 215 268.085 215 270.469V292",
    stroke: "black",
    strokeWidth: 3
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 278.246,
    r: 3,
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M144 266V294",
    stroke: "black",
    strokeWidth: 3
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 205.5,
    cy: 278.246,
    r: 3,
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M199 266V294",
    stroke: "black",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.336,
    cy: 217.259,
    rx: 112.836,
    ry: 30.4523,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_q2aNpSyoQHmG2jAxOvcU9c5EXspmYBjwS2mkeCQ7078",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 206,
    width: 229,
    height: 45
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.5 208.246H57.5001V219.246C57.5001 235.814 108.092 249.246 170.5 249.246C232.908 249.246 283.5 235.814 283.5 219.246V208.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5001 208.246V206.746C56.6716 206.746 56.0001 207.417 56.0001 208.246H57.5001ZM283.5 208.246H285C285 207.417 284.328 206.746 283.5 206.746V208.246ZM57.5001 209.746H283.5V206.746H57.5001V209.746ZM59.0001 219.246V208.246H56.0001V219.246H59.0001ZM170.5 247.746C139.387 247.746 111.273 244.396 90.9819 239.009C80.8254 236.313 72.7142 233.128 67.1776 229.653C61.5644 226.129 59.0001 222.574 59.0001 219.246H56.0001C56.0001 224.202 59.7597 228.539 65.5827 232.193C71.4823 235.897 79.9196 239.176 90.2121 241.909C110.819 247.38 139.205 250.746 170.5 250.746V247.746ZM282 219.246C282 222.574 279.436 226.129 273.823 229.653C268.286 233.128 260.175 236.313 250.018 239.009C229.727 244.396 201.613 247.746 170.5 247.746V250.746C201.795 250.746 230.181 247.38 250.788 241.909C261.081 239.176 269.518 235.897 275.417 232.193C281.24 228.539 285 224.202 285 219.246H282ZM282 208.246V219.246H285V208.246H282Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_q2aNpSyoQHmG2jAxOvcU9c5EXspmYBjwS2mkeCQ7078)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 73.0001,
    y: 211,
    width: 211,
    height: 41,
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5001 208.246V206.746C56.6716 206.746 56.0001 207.417 56.0001 208.246H57.5001ZM283.5 208.246H285C285 207.417 284.328 206.746 283.5 206.746V208.246ZM57.5001 209.746H283.5V206.746H57.5001V209.746ZM59.0001 219.246V208.246H56.0001V219.246H59.0001ZM170.5 247.746C139.387 247.746 111.273 244.396 90.9819 239.009C80.8254 236.313 72.7142 233.128 67.1776 229.653C61.5644 226.129 59.0001 222.574 59.0001 219.246H56.0001C56.0001 224.202 59.7597 228.539 65.5827 232.193C71.4823 235.897 79.9196 239.176 90.2121 241.909C110.819 247.38 139.205 250.746 170.5 250.746V247.746ZM282 219.246C282 222.574 279.436 226.129 273.823 229.653C268.286 233.128 260.175 236.313 250.018 239.009C229.727 244.396 201.613 247.746 170.5 247.746V250.746C201.795 250.746 230.181 247.38 250.788 241.909C261.081 239.176 269.518 235.897 275.417 232.193C281.24 228.539 285 224.202 285 219.246H282ZM282 208.246V219.246H285V208.246H282Z",
    fill: "black"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.5,
    cy: 208.246,
    rx: 113,
    ry: 30,
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    stroke: "black",
    strokeWidth: 3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.5,
    cy: 208.246,
    rx: 113,
    ry: 30,
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M195.475 212.408L218.214 192.11M237.942 220.934L273.408 205.9M102.966 221.842L67.5001 206.808M141.048 213.324L118.839 193.355",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.5,
    cy: 206.246,
    rx: 106,
    ry: 25,
    fill: "white"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1_q2aNpSyoQHmG2jAxOvcU9c5EXspmYBjwS2mkeCQ7078",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 184,
    width: 193,
    height: 45
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.5,
    cy: 206.246,
    rx: 96,
    ry: 22.08,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_q2aNpSyoQHmG2jAxOvcU9c5EXspmYBjwS2mkeCQ7078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.5 210.746C147.5 210.746 159.5 209.746 170.5 209.746C181.5 209.746 193.5 210.746 193.5 210.746",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.5 211.746C202.5 211.746 208 212.246 214 213.246C220 214.246 227.5 216.746 227.5 216.746",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.5 188.746C217.5 188.746 225.42 189.597 234.06 191.296C242.7 192.996 253.5 197.246 253.5 197.246",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.5 201.746C261.5 201.746 262.6 202.747 263.8 204.746C265 206.746 266.5 211.746 266.5 211.746",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.3 204.046C258.3 204.046 259.4 205.046 260.6 207.046C261.8 209.046 263.3 214.046 263.3 214.046",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.2 206.346C255.2 206.346 256.3 207.347 257.5 209.346C258.7 211.346 260.2 216.346 260.2 216.346",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252 208.746C252 208.746 253.1 209.747 254.3 211.746C255.5 213.746 257 218.746 257 218.746",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.8 210.946C248.8 210.946 249.9 211.947 251.1 213.946C252.3 215.946 253.8 220.946 253.8 220.946",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.5 213.246C245.5 213.246 246.6 214.247 247.8 216.246C249 218.246 250.5 223.246 250.5 223.246",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.4 215.646C242.4 215.646 243.5 216.646 244.7 218.646C245.9 220.646 247.4 225.646 247.4 225.646",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.5 217.746C239.5 217.746 240.6 218.747 241.8 220.746C243 222.746 244.5 227.746 244.5 227.746",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.5 219.746C236.5 219.746 237.6 220.747 238.8 222.746C240 224.746 241.5 229.746 241.5 229.746",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5001 201.746C79.5001 201.746 78.4001 202.747 77.2001 204.746C76.0001 206.746 74.5001 211.746 74.5001 211.746",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7 204.046C82.7 204.046 81.6 205.046 80.4 207.046C79.2 209.046 77.7 214.046 77.7 214.046",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8001 206.346C85.8001 206.346 84.7001 207.347 83.5001 209.346C82.3001 211.346 80.8001 216.346 80.8001 216.346",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0001 208.746C89.0001 208.746 87.9001 209.747 86.7001 211.746C85.5001 213.746 84.0001 218.746 84.0001 218.746",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2 210.946C92.2 210.946 91.1 211.947 89.9 213.946C88.7 215.946 87.2 220.946 87.2 220.946",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5001 213.246C95.5001 213.246 94.4001 214.247 93.2001 216.246C92.0001 218.246 90.5001 223.246 90.5001 223.246",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6 215.646C98.6 215.646 97.5 216.646 96.3 218.646C95.1 220.646 93.6 225.646 93.6 225.646",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5 217.746C101.5 217.746 100.4 218.747 99.2001 220.746C98.0001 222.746 96.5001 227.746 96.5001 227.746",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5 219.746C104.5 219.746 103.4 220.747 102.2 222.746C101 224.746 99.5001 229.746 99.5001 229.746",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.3 192.046C215.3 192.046 222.89 192.846 231.17 194.446C239.45 196.046 249.8 200.046 249.8 200.046",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.2 195.346C213.2 195.346 220.46 196.097 228.38 197.596C236.3 199.096 246.2 202.846 246.2 202.846",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 198.546C211 198.546 218.93 199.246 226.49 200.646C234.05 202.046 242.5 205.546 242.5 205.546",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 201.746C209 201.746 215.49 202.396 222.57 203.696C229.65 204.996 238.5 208.246 238.5 208.246",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.7 205.046C206.7 205.046 212.882 205.646 219.626 206.846C226.37 208.046 234.8 211.046 234.8 211.046",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.6 208.446C204.6 208.446 210.452 208.997 216.836 210.096C223.22 211.196 231.2 213.946 231.2 213.946",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5 211.746C138.5 211.746 133 212.246 127 213.246C121 214.246 113.5 216.746 113.5 216.746",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.5 188.746C123.5 188.746 115.58 189.597 106.94 191.296C98.3001 192.996 87.5001 197.246 87.5001 197.246",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7 192.046C125.7 192.046 118.11 192.846 109.83 194.446C101.55 196.046 91.2 200.046 91.2 200.046",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.8 195.346C127.8 195.346 120.54 196.097 112.62 197.596C104.7 199.096 94.8001 202.846 94.8001 202.846",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 198.546C130 198.546 121.07 199.25 113.51 201.15C105.95 202.55 98.5001 205.546 98.5001 205.546",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 201.746C132 201.746 125.51 202.396 118.43 203.696C111.35 204.996 102.5 208.246 102.5 208.246",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.3 205.046C134.3 205.046 128.118 205.646 121.374 206.846C114.63 208.046 106.2 211.046 106.2 211.046",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.4 208.446C136.4 208.446 130.548 208.997 124.164 210.096C117.78 211.196 109.8 213.946 109.8 213.946",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5 207.246C145.5 207.246 158.544 206.246 170.5 206.246C182.457 206.246 195.5 207.246 195.5 207.246",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5 204.096C143.5 204.096 157.587 202.996 170.5 202.996C183.413 202.996 197.5 204.096 197.5 204.096",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.25 200.696C141.25 200.696 156.576 199.496 170.625 199.496C184.674 199.496 200 200.696 200 200.696",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 197.496C139 197.496 155.435 195.996 170.5 195.996C185.565 195.996 202 197.496 202 197.496",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.7 194.196C136.7 194.196 154.309 192.496 170.45 192.496C186.591 192.496 204.2 194.196 204.2 194.196",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.5 190.946C134.5 190.946 153.283 189.146 170.5 189.146C187.717 189.146 206.5 190.946 206.5 190.946",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.5 187.746C132.5 187.746 152.326 185.746 170.5 185.746C188.674 185.746 208.5 187.746 208.5 187.746",
    stroke: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "0.05 4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 170.5,
    cy: 228,
    rx: 56.5,
    ry: 13,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.717 184.166L144.58 214.118",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.22 197.27L113.626 221.606",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.283 184.166L196.42 214.118",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.78 197.27L227.375 221.606",
    stroke: "white",
    strokeWidth: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllCartSuccessstyled);
export default __webpack_public_path__ + "static/media/ill-cart-success.styled.b474dba9.svg";
export { ForwardRef as ReactComponent };